import React, { useEffect, useRef, useState } from 'react';

import { Modal as flowbiteModal } from 'flowbite';

import PurchaseRequisitionProcurementMethodModal from '../purchase_requisitions/PurchaseRequisitionProcurementMethodModal';

import ProcurementEditForm from './ProcurementEditForm';

import { modalOptions } from 'Helpers/modalOptions';

import FullScreenSpinner from 'CommonComponents/FullScreenSpinner';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ProcurementEditModal(props) {
    const [
        purchaseRequisitionProcurementMethodModalForProcurementEditModalElement,
        setPurchaseRequisitionProcurementMethodModalForProcurementEditModalElement,
    ] = useState(null);

    const purchaseRequisitionProcurementMethodModalForProcurementEditModalRef = useRef();

    const [actionCompleted, setActionCompleted] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [actionFailed, setActionFailed] = useState(false);

    useEffect(() => {
        purchaseRequisitionProcurementMethodModalForProcurementEditModalRef &&
            setPurchaseRequisitionProcurementMethodModalForProcurementEditModalElement(
                new flowbiteModal(purchaseRequisitionProcurementMethodModalForProcurementEditModalRef.current, modalOptions(false)),
            );
    }, []);

    const resetData = () => {
        purchaseRequisitionProcurementMethodModalForProcurementEditModalElement &&
            purchaseRequisitionProcurementMethodModalForProcurementEditModalElement.hide();
    };

    const closeModal = () => {
        resetData();
    };

    const successHandler = () => {
        resetData();
    };

    const cleanConfirmationModalStates = () => {
        setActionInProgress(false);
        setActionFailed(false);
        setActionCompleted(false);
    };

    const showPurchaseRequisitionProcurementMethodModal = () => {
        purchaseRequisitionProcurementMethodModalForProcurementEditModalElement &&
            purchaseRequisitionProcurementMethodModalForProcurementEditModalElement.show();
    };

    return (
        <>
            <PurchaseRequisitionProcurementMethodModal
                closeHandler={closeModal}
                successHandler={successHandler}
                cleanStates={cleanConfirmationModalStates}
                allowAction={true}
                modalId={'pr-method-list-edit-modal'}
                modalRef={purchaseRequisitionProcurementMethodModalForProcurementEditModalRef}
                modalElement={purchaseRequisitionProcurementMethodModalForProcurementEditModalElement}
                request={actionInProgress}
                actionCompleted={actionCompleted}
                actionFailed={actionFailed}
                title={$t('Procurement Policies')}
                cancelButtonText={$t('Close')}
                policies={props.policies}
            />
            <Modal id={props.id} modal={props.modal} parentContainerClasses="!tw-max-w-7xl">
                <ModalHeader title={$t('Edit Procurement')} close={props.onClose}></ModalHeader>
                <div className="tw-rounded-b">
                    {props.reSyncing && <FullScreenSpinner />}
                    {props.loading ? (
                        <LoadingSpinner />
                    ) : !props.fetched ? (
                        <div className="modal__form-container">
                            <label className="modal__msg modal__error-text-color">{$t('Data not fetched')}</label>
                        </div>
                    ) : (
                        <div className="modal__form-container">
                            <ProcurementEditForm
                                procurement={props.procurement}
                                policies={props.policies}
                                categories={props.categories}
                                priorities={props.priorities}
                                complexities={props.complexities}
                                statuses={props.statuses}
                                expensesTree={props.expensesTree}
                                expensesIds={props.expensesIds}
                                arrow={props.arrow}
                                saveUrl={props.saveUrl}
                                storePRUrl={props.storePRUrl}
                                indexPRUrl={props.indexPRUrl}
                                syncExpensesUrl={props.syncExpensesUrl}
                                syncExpenseablesUrl={props.syncExpenseablesUrl}
                                downloadAttachmentUrl={props.downloadAttachmentUrl}
                                deleteAttachmentUrl={props.deleteAttachmentUrl}
                                existedIds={props.existedIds}
                                setOrdering={props.setOrdering}
                                isCreatePrMode={props.isCreatePrMode}
                                setLoading={props.setLoading}
                                closeHandler={props.onClose}
                                eventStartDate={props.eventStartDate}
                                eventEndDate={props.eventEndDate}
                                onEdit={props.onEdit}
                                onCancelEdit={props.onCancelEdit}
                                onCancel={props.onCancel}
                                onCreated={props.onCreated}
                                onExpensesSynced={props.onExpensesSynced}
                                onAttachmentDeleted={props.onAttachmentDeleted}
                                onRefresh={props.onRefresh}
                                onSuccess={() => {
                                    props.onClose();
                                    props.onSuccess();
                                }}
                                showInfo={showPurchaseRequisitionProcurementMethodModal}
                                lockedExpenseIds={props.lockedExpenseIds}
                            />
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
}
